import React, { Component } from 'react';
import { BrowserRouter } from 'react-router-dom'
import './App.css';
import Facil from './components/Facil.js';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

export default class App extends Component {


  render() {
    return (
      <div className="App">
        <BrowserRouter>
            <MuiThemeProvider>
                <Facil />
            </MuiThemeProvider>
        </BrowserRouter>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js